import * as moment from 'moment';
import { Moment } from 'moment';
import Spouse from 'src/value-objects/Spouse';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import InvestorType from 'src/entities/InvestorType';
import { isNullOrUndefined } from 'util';

export interface PhysicalPersonProperties {
  id: number;
  name: string;
  displayName?: string;
  surname: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: string;
  idBack?: string;
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: string;
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  about?: string;
  investmentGoal?: string;
  sectorsOfInterest: SectorOfInterest[];
  personType: string;
  investorType: InvestorType;
  isPublicProfile?: boolean;
  percentCompleted?: number;
}

export default class PhysicalPerson {
  id: number;
  name: string;
  surname: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: string;
  idBack?: string;
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: string;
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  about?: string;
  investmentGoal?: string;
  sectorsOfInterest: SectorOfInterest[];
  personType: string;
  displayName: string;
  investorType: InvestorType;
  isPublicProfile: boolean;
  percentCompleted?: number;

  constructor(entity: PhysicalPersonProperties) {
    this.id = entity.id;
    this.name = entity.name;
    this.displayName = entity.displayName || '';
    this.surname = entity.surname;
    this.nationality = entity.nationality || undefined;
    this.idNumber = entity.idNumber || undefined;
    this.idExpirationDate = entity.idExpirationDate ? moment.utc(entity.idExpirationDate) : undefined;
    this.idFront = entity.idFront || undefined;
    this.idBack = entity.idBack || undefined;
    this.birthDate = entity.birthDate ? moment.utc(entity.birthDate) : undefined;
    this.phoneNumber = entity.phoneNumber || undefined;
    this.notificationEmail = entity.notificationEmail || undefined;
    this.email = entity.email || undefined;
    this.address = entity.address || undefined;
    this.houseNumber = entity.houseNumber || undefined;
    this.zipCode = entity.zipCode || undefined;
    this.city = entity.city || undefined;
    this.province = entity.province || undefined;
    this.country = entity.country || undefined;
    this.maritalStatus = entity.maritalStatus || undefined;
    this.maritalEconomicStatus = entity.maritalEconomicStatus || undefined;
    this.maritalPropertyRegime = entity.maritalPropertyRegime || undefined;
    this.occupationType = entity.occupationType || undefined;
    this.occupation = entity.occupation || undefined;
    this.company = entity.company || undefined;
    this.spouse = entity.spouse ? new Spouse(entity.spouse) : undefined;
    this.profilePicture = entity.profilePicture || undefined;
    this.facebookProfile = entity.facebookProfile || undefined;
    this.twitterProfile = entity.twitterProfile || undefined;
    this.linkedinProfile = entity.linkedinProfile || undefined;
    this.about = entity.about || undefined;
    this.investmentGoal = entity.investmentGoal || undefined;
    this.sectorsOfInterest = entity.sectorsOfInterest ?
      entity.sectorsOfInterest.map(sector => new SectorOfInterest(sector)) :
      [];
    this.personType = entity.personType;
    this.investorType = new InvestorType(entity.investorType);
    this.isPublicProfile = entity.isPublicProfile || false;
    this.percentCompleted = entity.percentCompleted || 0;
  }

  // TODO stop using this!
  public isProfileCompleted(): boolean {
    let notNull = !isNullOrUndefined(this.name) && !isNullOrUndefined(this.surname) &&
      !isNullOrUndefined(this.nationality) &&
      !isNullOrUndefined(this.idNumber) &&
      !isNullOrUndefined(this.idFront) && !isNullOrUndefined(this.idBack) && !isNullOrUndefined(this.phoneNumber) &&
      !isNullOrUndefined(this.birthDate) && !isNullOrUndefined(this.email) && !isNullOrUndefined(this.address) &&
      !isNullOrUndefined(this.zipCode) && !isNullOrUndefined(this.city) && !isNullOrUndefined(this.province) &&
      !isNullOrUndefined(this.country) && !isNullOrUndefined(this.maritalStatus) &&
      !isNullOrUndefined(this.occupationType);

    if (this.maritalStatus === 'Casado/a' && this.maritalEconomicStatus === 'Régimen de gananciales') {
      notNull = notNull && !isNullOrUndefined(this.maritalPropertyRegime) && !isNullOrUndefined(this.spouse) &&
        !isNullOrUndefined(this.spouse.name) && !isNullOrUndefined(this.spouse.surname) &&
        !isNullOrUndefined(this.spouse.nationality) && !isNullOrUndefined(this.spouse.idNumber) &&
        !isNullOrUndefined(this.spouse.city) && !isNullOrUndefined(this.spouse.province) &&
        !isNullOrUndefined(this.spouse.country) && !isNullOrUndefined(this.spouse.zipCode);
    }

    return notNull;
  }
}



// WEBPACK FOOTER //
// ./src/entities/PhysicalPerson.tsx